

export class Juris {

    constructor() { }

    public JurisID: string;
    public JurisNo: number;
    public TenantID: string;
    public JurisName: string;
    public Location: string;
    public Address2: string;
    public City: string;
    public State: string;
    public StateName: string;
    public Zip: string;
    public ZipCode: string;
    public Latitude?: number;
    public Longitude?: number;
    public USNG: string;
    public SpatialData: string;
    public IsHeader?: number;
    public HeaderAlignment: string;
    public Percentage?: number;
    public IsActive?: number;
    public InactiveDttmUTC?: any;
    public Custom1: string;
    public Custom2: string;
    public CreatedPFID: string;
    public CreatedDttmUTC?: Date;
    public ModifiedPFID: string;
    public ModifiedDttmUTC?: Date;
    public FileAttachment:string;
    public FileType: string;
    public Username: string;
    public Password: string;
    public LogoSize: string;
    public LogoPath: string;
    public PhoneNumber: string;
    public PhoneExtension: string;
    public FaxNumber: string;
    public FaxExtension: string;
    public BGFileAttachment: string;
    public SetDefaultBackground: boolean = false;
    public BGFileType: string;
    public BGPath: string;
    public IsParkingPermitEnabled: boolean;
    public IsTaxicomplaintEnabled: boolean;
    public IsRecoverPwd: number;
    public EmailID: string;
    public Theme: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/juris.model.ts